import { useTranslation } from 'next-i18next';
import FormCTA from './FormCTA';
import { useAppointmentStore, useFormSectionStore } from '@src/store';
import { slugify } from '@src/utils/slugify';
export function RenderCTA({
  name,
  confirmAppointment
}: {
  name: string;
  confirmAppointment?: () => void;
}) {
  const {
    t
  } = useTranslation('formCTA');
  switch (name) {
    case 'Date & Time':
      return <FormCTA hideContinue={!useAppointmentStore.getState().appointmentSlot} primaryButtonText={t('continue')} onClick={e => {
        e.preventDefault();
        useFormSectionStore.getState().completeActiveNode();
      }} />;
    case 'Appointment Review':
      return <FormCTA isAppointmentReview onClick={confirmAppointment} primaryButtonText={t('confirmAppt')} />;
    case 'Confirmation':
      return null;
    default:
      return <FormCTA form={slugify(name)} primaryButtonText={t('continue')} />;
  }
}